export { default as LoyaltyLoader } from './loyalty-loader';
